module.exports = __webpack_public_path__ + "img/dp02.2945078b.jpg";